import { useRouterState } from "@tanstack/react-router";
import { useMemo } from "react";

/**
 * Read the `?focus=id1,id2,…` URL search param. Returns a Set of entity IDs
 * to spotlight. When empty, canvases should render normally (no dimming).
 *
 * Centralized so every canvas reads it the same way.
 */
export function useFocusSet(): Set<string> {
  const search = useRouterState({ select: (s) => s.location.search });
  return useMemo(() => {
    const raw = (search as Record<string, unknown>)?.focus;
    if (typeof raw !== "string" || !raw) return new Set<string>();
    return new Set(
      raw
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    );
  }, [search]);
}
